import ExpandableOptions from "modules/Core/sub-modules/ui-kit/components/ExpandableOptions";
import EditActivityButton from "../EditActivityButton";
import StampActivityButton from "../StampActivityButton";
import { STAMPS } from "modules/Core/consts";
import styles from "./styles.module.scss";

const CycleActivityOptions = ({
    activity,
    cycleId,
    refetch,
    extraOptions = [],
}) => (
    <ExpandableOptions
        horizontal
        className={styles.options}
        options={[
            ...extraOptions,
            {
                text: "Edit",
                Component: EditActivityButton,
                props: {
                    activity,
                    onSuccess: refetch,
                    text: "Edit",
                }
            },
            {
                text: "Stamp Commenced",
                Component: StampActivityButton,
                props: {
                    stampKey: STAMPS.COMMENCED,
                    activityId: activity?.id,
                    cycleId,
                    shouldRender: !activity?.stamps?.[STAMPS.COMMENCED],
                    text: "Stamp Commenced",
                    callback: refetch
                }
            },
            {
                text: "Stamp Completed",
                Component: StampActivityButton,
                props: {
                    stampKey: STAMPS.COMPLETED,
                    activityId: activity?.id,
                    cycleId,
                    shouldRender: !activity?.stamps?.[STAMPS.COMPLETED] && Boolean(activity?.stamps?.[STAMPS.COMMENCED]),
                    text: "Stamp Completed",
                    callback: refetch
                }
            },
        ]}
    />
)

export default CycleActivityOptions;
